import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-vouchers-wallet-stamp',
  templateUrl: './empty-vouchers-wallet-stamp.component.html',
  styleUrls: ['./empty-vouchers-wallet-stamp.component.scss'],
})
export class EmptyVouchersWalletStampComponent  implements OnInit {
  @Input() mode:'button'
  constructor() { }

  ngOnInit() {}

}
